import { StandardEvents } from '@shopify/events';

class DLNLowStock extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.revision = 0;
    document.addEventListener(StandardEvents.productSelect, this.onSelection, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onSelection = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const section = this.closest('.shopify-section');
    if (!section?.contains(event.target)) return;
    this.setAttribute('aria-busy', 'true');
    this.dataset.state = 'unavailable';
    const label = this.querySelector('[data-stock-label]');
    const detailText = this.querySelector('[data-stock-detail]');
    if (label) label.textContent = this.dataset.updatingLabel || '';
    if (detailText) detailText.textContent = '';
    const revision = ++this.revision;
    event.promise?.then(({ detail }) => {
      if (!this.isConnected || revision !== this.revision || !detail?.html) return;
      if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const updated = detail.html.querySelector(`dln-low-stock[data-product-id="${this.dataset.productId}"]`);
      if (updated) this.replaceWith(updated.cloneNode(true));
      else this.hidden = true;
    }).catch(() => {
      if (this.isConnected && revision === this.revision) this.hidden = true;
    });
  };
}

if (!customElements.get('dln-low-stock')) customElements.define('dln-low-stock', DLNLowStock);
